module.exports = __webpack_public_path__ + "static/img/9.71f68ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/9.png
// module id = OGaB
// module chunks = 0